// # interfaces
import { iPaymentCard } from '@/interfaces/payments';
// # models
import { NewsModel } from '@/models';
// # policies
import { newsPolicy } from '@/policies';
// # services
import { auth } from '@/services';

angular.module('app')
    .controller('manageNewsController', manageNewsController);

manageNewsController.$inject = [
    '$scope',
    '$rootScope',
    '$uibModalInstance',
    '$q',
    '$timeout',
    'alerts',
    'NewsApi',
    'UploadsApi',
    'newsId',
    'confirmDialog',
    'Helpers',
    'thisSiteSettings',
    'Users',
    'CategoryTypesApi',
    'CategoriesApi',
    'PollsApi',
];

function manageNewsController(
    $scope,
    $rootScope,
    $uibModalInstance,
    $q,
    $timeout,
    alerts,
    NewsApi,
    UploadsApi,
    newsId,
    confirmDialog,
    Helpers,
    thisSiteSettings,
    Users,
    CategoryTypesApi,
    CategoriesApi,
    PollsApi,
) {
    const user = auth.user();

    // properties
    $scope.permissionChecks = {
        canDelete: newsPolicy.canDelete(user),
        canManage: newsPolicy.canManage(user),
        canManageCreatedDate: newsPolicy.canManageCreatedDate(user),
        canManageStatus: newsPolicy.canManageStatus(user),
        billingRequired: newsPolicy.createPaymentRequired(user),
    };
    $scope.onlineBillingEnabled = thisSiteSettings.news_charge_accept_online_payments;
    $scope.thisSiteSettings = thisSiteSettings;
    $scope.isLoading = false;
    $scope.isLoadingProgress = 0;
    $scope.thisUser = $rootScope.thisUser;
    $scope.newsId = newsId;
    $scope.createNews = !newsId;
    $scope.categoryTypes = []; // each one with "categories" and "selectedCategoryId" array
    $scope.news = {

        categories: [],
        status: $scope.permissionChecks.canManagePost ? 'approved' : 'pending',
        settings: {},
    };
    $scope.statusOptions = [
        { label: 'Pending', value: 'pending' },
        { label: 'Approved', value: 'approved' },
        { label: 'Rejected', value: 'rejected' },
    ];
    $scope.imageUploadOptions = {
        resize: true,
        resizeShape: 'rectangle',
        resizeSize: {
            w: 1250,
            h: 640,
        },
        resizeAspectRatio: 0,
    };
    $scope.imageFile = null;
    $scope.formErrors = {};
    $scope.labels = {
        saveButton__create: $scope.onlineBillingEnabled && $scope.permissionChecks.billingRequired ? `Purchase for ${thisSiteSettings.currency_symbol}${thisSiteSettings.news_charge_price}` : 'Submit',
        saveButton__update: 'Save',
    };
    $scope.currencySymbol = thisSiteSettings.currency_symbol;

    // Check whether we need to load an existing news post
    if (!$scope.createNews) {
        getNews();
    }
    getPolls();


    // methods
    $scope.close = $uibModalInstance.close;
    $scope.handleBodyChange = handleBodyChange;
    $scope.handleImage = handleImage;
    $scope.handleImageError = handleImageError;
    $scope.submitNews = submitNews;
    $scope.deleteNews = deleteNews;
    $scope.getCategoryTypes = getCategoryTypes;
    $scope.getCategories = getCategories;
    $scope.setCategories = setCategories;
  /**
     * Initialises the controller.
     *
     * @returns {Promise<void>}
     */
    async function bootstrap(): Promise<void> {
        try {
            $scope.isLoading = true;

            if (newsId) {
                await getNews();
            }

            await getCategoryTypes();
            $scope.isLoading = false;
            $scope.$apply();
        } catch (error) {
            $scope.isLoading = false;
            throw error;
        }
    }
        /**
     * Retrieves category types from the API
     *
     * @returns {Promise<void>}
     */
    function getCategoryTypes(): Promise<void> {
        return new Promise((resolve, reject) => {
            CategoryTypesApi.query(
                { "categorizables[]": ['news'] },
                async (response: any) => {
                    $scope.categoryTypes = response;
                    await getCategories();
                    resolve();
                },
                reject,
            );
        });
    }

    /**
     * Retrieves categories from the API
     *
     * @returns {Promise<void>}
     */
    function getCategories(): Promise<void> {
        return new Promise((resolve, reject) => {
            CategoriesApi.query(response => {
                $scope.categories = response;
                angular.forEach($scope.categoryTypes, categoryType => {
                    const cats = $scope.categories.filter(cat => {
                        return cat.type_id === categoryType.id;
                    });

                    categoryType.categories = cats;
                });
                resolve();
            }, reject);
        });
    }
    /**
     * Loads a news to be edited
     * @return {void}
     */
    function getNews() {
        $scope.isLoadingMessage = 'Loading news...';
        $scope.isLoading = true;

        NewsApi.get({
            id: $scope.newsId,
        }, response => {
            // Add news to scope
            angular.extend($scope.news, response.data);
            if (!$scope.news.settings) {
                $scope.news.settings = {};
            }

            // update permission checks
            $scope.permissionChecks.canDelete = newsPolicy.canDelete(user, new NewsModel($scope.news));

            setCategories($scope.event.categories.map(function(d) { return d['id']; }));
            $scope.isLoading = false;
        }, () => {
            $scope.isLoading = false;
        });
    }

    /**
     * Updates the body content.
     *
     * @param {string} content html
     */
    function handleBodyChange(content) {
        $scope.news.body = content;
    }

    /**
     * Handles the image chosen by the user
     * @param  {file} file - base64 image file
     * @return {void}
     */
    function handleImage(file) {
        $scope.imageFile = file;
    }

    /**
     * Shows file errors
     * @param  {object} imageError - provide as  {image: '[message]'}
     * @return {void}
     */
    function handleImageError(imageError) {
        $scope.formErrors = angular.merge($scope.formError, imageError);
    }

    /**
     * Shows the choose payment card modal if payment is required to create this post
     *
     * @return {Promise<null | iPaymentCard>}
     */
    function handlePaymentIfRequired(): Promise<null | iPaymentCard> {
        return new Promise((resolve, reject) => {
            if ($scope.news.id) {
                return resolve(null);
            }

            if ($scope.onlineBillingEnabled && $scope.permissionChecks.billingRequired) {
                Users.manageCard().result
                    .then(resolve)
                    .catch(reject);
            } else {
                resolve(null);
            }
        });
    }

    /**
     * Submits the news to the server
     */
    function submitNews() {
        let funcName;
        let params;

        $scope.isLoading = true;

        if ($scope.imageFile) {
            $scope.isLoadingMessage = 'Uploading image...';
        }

        if ($scope.createNews) {
            funcName = 'save';
            params = {
                id: $scope.newsId,
            };
        } else {
            funcName = 'update';
            params = {};
        }

        function error(err) {
            $scope.isLoading = false;
            $scope.formErrors = err.data;
        }

        handlePaymentIfRequired().then(card => {
            if (card && card.stripe_id) {
                $scope.news.stripe_id = card.stripe_id;
            }

            UploadsApi.uploadImage($scope.imageFile, 'site')
                .then(
                    img => {
                        // hide progress bar
                        $scope.isLoadingProgress = false;

                        // add uploaded image path to news
                        if (img && img.path) {
                            $scope.news.img = img.path;
                        }

                        // set relevant loading message
                        $scope.isLoadingMessage = ($scope.createNews ? 'Creating news post...' : 'Saving news post...');

                        // don't modify the original object
                        const preparedPost = {
                            ...$scope.news,
                        };

                        if ($scope.permissionChecks.canManage) {
                            preparedPost.created_at = window.moment($scope.news.created_at).local().format(Helpers.isoFormat);
                        } else {
                            delete preparedPost.created_at;
                        }

                        NewsApi[funcName](params, preparedPost, response => {
                            // wait for UI prettiness
                            // eslint-disable-next-line prefer-arrow-callback
                            $timeout(() => {
                                $scope.isLoading = false;

                                alerts.emit({
                                    theme: 'success',
                                    title: ($scope.news.id ? 'News post saved' : 'Your news post has been submitted!'),
                                });

                                // close modal
                                $uibModalInstance.close(response.data);
                            }, 400);
                        }, error).suppressValidationAlerts();
                    },
                    error,
                    progress => {
                        $scope.isLoadingProgress = progress;
                    },
                );
        });

    }

    function deleteNews() {
        confirmDialog('Are you sure you want to delete this post?')
            .result.then(confirm => {
                if (confirm) {
                    $scope.isLoadingMessage = 'Deleting...';
                    $scope.isLoading = true;

                    NewsApi.delete({
                        id: $scope.news.id,
                    }, function handleDeleteNewsResponse(response) {
                        $scope.forceClose = true;
                        $scope.news.deleted = true;
                        $uibModalInstance.close($scope.news);
                    }, function handleDeleteNewsError() {
                        $scope.isLoading = false;
                    });
                }
            });
    }
    /**
     * Replaces selected categories on the resources object.
     *
     * @param {number[]} categoryIds
     * @returns {void}
     */
    function setCategories(categoryIds: number[]): void {
        $scope.news.categories = categoryIds;
        $scope.$apply();
    }

    /**
     * Retrieves polls
     *
     * @return {void}
    */
    function getPolls() {
        PollsApi.get({
            status: 'approved',
        }, response => {
            $scope.polls = response.data;
        });
    }

    bootstrap();
    $scope.$on('modal.closing', (event, reason, closed) => {
        if (!closed && !$scope.forceClose) {
            return event.preventDefault();
        }

        return true;
    });
}
